import { Component, Directive, ElementRef, OnInit, ViewChild, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder } from '@angular/forms';


@Component({
  selector: 'app-schools-districts-modal',
  templateUrl: './schools-districts-modal.component.html',
  styleUrls: ['./schools-districts-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SchoolsDistrictsModalComponent implements OnInit {
 constructor(
    public dialogRef: MatDialogRef<SchoolsDistrictsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public editData: any,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder
  ) {
  }

  ngOnInit(): void {

  }
}
